module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-005.5bbe2d32.png";